import type { TextSize } from './interface';

type TextValues = {
  [key in TextSize]: {
    fontSize: number;
    fontWeight: number;
    lineHeight: number;
    letterSpacing: number;
  };
};

// WARNING: If each text size has a unique Text Weight, we won't be able
// to unset formatting without requiring a size be provided.
const TEXT_WEIGHT = 420;
const BOLD_WEIGHT = 700;
const LETTER_SPACING = 0;

const TEXT_VALUES: TextValues = {
  l: {
    fontSize: 16,
    fontWeight: TEXT_WEIGHT,
    lineHeight: 24,
    letterSpacing: LETTER_SPACING,
  },
  m: {
    fontSize: 14,
    fontWeight: TEXT_WEIGHT,
    lineHeight: 20,
    letterSpacing: LETTER_SPACING,
  },
  s: {
    fontSize: 12,
    fontWeight: TEXT_WEIGHT,
    lineHeight: 16,
    letterSpacing: LETTER_SPACING,
  },
};

export { TEXT_VALUES, BOLD_WEIGHT, TEXT_WEIGHT, LETTER_SPACING };
